__turbopack_context__.v({
  "button": "addToCartForm-module-scss-module__RbkEBW__button",
  "form": "addToCartForm-module-scss-module__RbkEBW__form",
  "quantityInput": "addToCartForm-module-scss-module__RbkEBW__quantityInput",
});
